import(/* webpackMode: "eager" */ "/app/app/docs/[pdf]/page.tsx");
